// extracted by mini-css-extract-plugin
export default {"appShell":"app_appShell__p7QxG","appMain":"app_appMain__XDp5G","appFooter":"app_appFooter__uJmtd","configStartup":"app_configStartup__eWGmU"};